// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3Ia0l","list":"PatternAutocomplete_list__3Qk59"};